var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useAppSelector } from "../../store/hooks";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetCommonReducer, showLoader } from "../../redux/commonSlice";
import { logOutURL } from '../../api/url';
import { Post } from "../../api/api";
import { clearLocalStorage } from "../../utils/storageHelper";
import { deleteState, resetAfterLogOutCrud, setState } from "../../redux/crudSlice";
import { resetAfterLogOutAuth } from "../../redux/authSlice";
var NoMenuListDialog = function () {
    var _crud$assignModuleDat;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var crud = useAppSelector(function (state) { return state.crud; });
    var menuList = (_crud$assignModuleDat = crud['assignModuleDataList']) === null || _crud$assignModuleDat === void 0 ? void 0 : _crud$assignModuleDat.data;
    var handleSignOutClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, Post(logOutURL)];
                case 1:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    navigate('/');
                    clearLocalStorage();
                    dispatch(deleteState({
                        key: 'assignModuleDataList'
                    }));
                    dispatch(setState({
                        key: 'clearStorage',
                        value: true
                    }));
                    dispatch(resetCommonReducer());
                    dispatch(resetAfterLogOutCrud());
                    dispatch(resetAfterLogOutAuth());
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: (menuList === null || menuList === void 0 ? void 0 : menuList.length) === 0,
        "aria-labelledby": "no-menu-modal"
    }, /*#__PURE__*/ React.createElement(DialogTitle, {
        id: "no-menu-modal",
        fontSize: '16px',
        fontWeight: '600'
    }, "No Roles Assigned"), /*#__PURE__*/ React.createElement(DialogContent, null, /*#__PURE__*/ React.createElement(DialogContentText, null, "Menu access is not tagged. Please contact your administrator to assign a role from the Vahaan portal to proceed with transactions.")), /*#__PURE__*/ React.createElement(DialogActions, null, /*#__PURE__*/ React.createElement(Button, {
        onClick: function () { return handleSignOutClick(); },
        color: "primary"
    }, "Close")));
};
export default NoMenuListDialog;
